import { CheckBox, PostAddSharp } from "@mui/icons-material";
import { Box, Switch, TextField } from "@mui/material";
import { Stack } from "@mui/system";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
import { EVALUE } from "../../helpers/consts";

type PDateTimePicker = {
    field: string;
    evalue: EVALUE;
    onChange: any;
    enabled: boolean;
};

export default function CDateTimePicker(props: PDateTimePicker) {
    const [enabled, setEnabled] = useState(props.enabled);
    const [value, setValue] = useState();

    const onChange = (value_: any) => {
        setValue(value_);
    };

    useEffect(() => {
        props.onChange(enabled, props.field, props.evalue, value);
    }, [value, enabled]);

    return (
        
            <Stack direction="row" spacing={1} alignItems={"center"} justifyContent='space-between'>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                   
                    <DateTimePicker
                            disabled={!enabled}
                            views={["year", "month", "day", "hours", "minutes", "seconds"]}
                            renderInput={(props) => <TextField sx={{maxWidth:'216px'}} {...props} />}
                            ampm={false}
                            inputFormat={"YYYY-MM-DD HH:mm:ss"}
                            mask="____-__-__ __:__:__"
                            value={value}
                            onChange={onChange}
                        />
                   
                </LocalizationProvider>

                <Switch size="small" onChange={(_, c) => setEnabled(c)} />
            </Stack>
        
    );
}
